import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";
import { formatErr } from "@/lib/api";

export default function AdminLogin() {
  const { login, user } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("admin@larcraft.shop");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  React.useEffect(() => { if (user) navigate("/admin", { replace: true }); }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    try {
      await login(email, password);
      navigate("/admin", { replace: true });
    } catch (err) {
      setError(formatErr(err, "Giriş başarısız"));
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-larc-admin flex items-center justify-center px-6" data-testid="admin-login-page">
      <div className="w-full max-w-md bg-white border border-larc-border rounded-2xl p-10 shadow-[0_8px_30px_rgba(45,38,34,0.04)]">
        <Link to="/" className="flex items-center justify-center gap-3 mb-8">
          <span className="inline-flex h-9 w-9 items-center justify-center rounded-full border border-larc-gold/40">
            <span className="block h-3 w-3 rounded-full bg-larc-gold" />
          </span>
          <span className="font-heading text-3xl italic">Larcraft</span>
        </Link>
        <h1 className="font-heading text-3xl text-center">Yönetim Paneli</h1>
        <p className="text-center text-larc-muted text-sm mt-1">Atölye yönetim sistemine giriş yapın.</p>

        <form onSubmit={submit} className="mt-8 space-y-5">
          <label className="block">
            <span className="text-xs uppercase tracking-[0.15em] text-larc-muted">E-posta</span>
            <input data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-2 w-full border border-larc-border rounded-lg px-4 py-3 outline-none focus:border-larc-gold text-sm" />
          </label>
          <label className="block">
            <span className="text-xs uppercase tracking-[0.15em] text-larc-muted">Şifre</span>
            <input data-testid="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="mt-2 w-full border border-larc-border rounded-lg px-4 py-3 outline-none focus:border-larc-gold text-sm" />
          </label>
          {error && <div className="text-sm text-red-600 bg-red-50 border border-red-100 rounded-lg px-4 py-2.5" data-testid="login-error">{error}</div>}
          <button disabled={loading} className="w-full inline-flex items-center justify-center gap-2 bg-larc-ink text-white rounded-full px-6 py-3.5 text-sm hover:bg-larc-gold transition-colors disabled:opacity-50" data-testid="login-submit">
            {loading ? "Giriş…" : "Giriş Yap"} <ArrowRight size={16} />
          </button>
        </form>
      </div>
    </div>
  );
}
